
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"72","height":"72"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#95989A","fill-rule":"evenodd","d":"M30 15v42a3 3 0 01-3 3H9a3 3 0 01-3-3V15a3 3 0 013-3h18a3 3 0 013 3zm15 24h-6a3 3 0 00-3 3v15a3 3 0 003 3h6a3 3 0 003-3V42a3 3 0 00-3-3zm18 0h-6a3 3 0 00-3 3v15a3 3 0 003 3h6a3 3 0 003-3V42a3 3 0 00-3-3zm0-27H39a3 3 0 00-3 3v15a3 3 0 003 3h24a3 3 0 003-3V15a3 3 0 00-3-3z"}})])
          )
        }
      }
    